<template>
  <div class="flex flex-row justify-center h-full w-full">
    <div class="content-form flex flex-col flex-grow">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "ContentForm"
};
</script>

<style scoped>
.content-form {
  max-width: 14.625rem;
}
@media (min-width: 768px) {
  .content-form {
    max-width: 16.9375rem;
  }
}
</style>
